import * as Yup from 'yup';
import {Constants} from "../../../../v1/utils/constants"
export default Yup.object().shape({
    currentPassword: Yup.string().required("This field is required."),
    newPassword: Yup.string().matches(Constants.REGEXP.PASSWORD, { message:"Your password must be at least 6 characters long and include at least one uppercase letter and one number.", excludeEmptyString: true }).required("This field is required."),
});